import Loadable from '../../components/loadable';

const SignedWaiversList = Loadable({
  loader: () => import('../../pages/waivers/signed_waivers_list/signed_waivers_list'),
  type: 'block',
});

angular.module('gym').value('SignedWaiversList', SignedWaiversList);

const SignedWaiversListFiltersModal = Loadable({
  loader: () => import('../../pages/waivers/signed_waivers_list/signed_waivers_list_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('SignedWaiversListFiltersModal', SignedWaiversListFiltersModal);

const DeleteSignedWaiverModal = Loadable({
  loader: () => import('../../pages/waivers/signed_waivers_list/delete_signed_waiver_modal'),
  type: 'modal',
});

angular.module('gym').value('DeleteSignedWaiverModal', DeleteSignedWaiverModal);
